import React, { useState, useEffect } from 'react';
import './styles.css';
import { AuthProvider, useAuth } from './AuthContext';
import { setAuthToken } from './api';
import LoginScreen from './screens/LoginScreen';
import ListDeliveryScreen from './screens/ListDeliveryScreen';
import OrderItemScreen from './screens/OrderItemScreen';
import OrdersHistoryScreen from './screens/OrdersHistoryScreen';
import LogoutScreen from './screens/LogoutScreen';

const Router = () => {
  const { isLoggedIn, token } = useAuth();
  const [screen, setScreen] = useState(isLoggedIn ? 'list' : 'login');
  const [params, setParams] = useState({});

  useEffect(() => {
    setAuthToken(token);
  }, [token]);

  const navigate = (to, p = {}) => {
    setParams(p);
    setScreen(to);
    window.scrollTo(0, 0);
  };

  if (!isLoggedIn && screen !== 'login') {
    return <LoginScreen navigate={navigate} />;
  }

  switch (screen) {
    case 'login':    return <LoginScreen navigate={navigate} />;
    case 'list':     return <ListDeliveryScreen navigate={navigate} />;
    case 'order':    return <OrderItemScreen navigate={navigate} params={params} />;
    case 'history':  return <OrdersHistoryScreen navigate={navigate} />;
    case 'logout':   return <LogoutScreen navigate={navigate} />;
    default:         return <ListDeliveryScreen navigate={navigate} />;
  }
};

export default function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}
